export enum TaxNoticeType {
  DEFAULT = 100,
  CUSTOM = 200,
}

export const allCases = [TaxNoticeType.DEFAULT, TaxNoticeType.CUSTOM];
